export default __webpack_public_path__ + "files/media/icon.e19a1e91.svg";